import React, {FC, ReactNode} from 'react';
import ReactDOM from 'react-dom';
import styles from './tooltip.module.scss';
import helpIcon from '../../../images/help.svg';
import {useTooltipPosition} from "../../../hooks/useTooltipPosition";
import { useTranslation } from 'react-i18next';
import {isRTL} from "../../../utils/rtl";

interface classesTooltip {
    image?: string;
    text?: string;
}

export interface TooltipProps {
    text: string | ReactNode;
    delay?: number;
    position?: 'right' | 'bottom';
    children?: ReactNode;
    disabled?: boolean;
    classes?: classesTooltip
}

const Tooltip: FC<TooltipProps> = ({ text, delay = 350, position = 'right', children, disabled = false, classes = {} }) => {
  const { t } = useTranslation();
    const {
        iconRef,
        coords,
        visible,
        showTooltip,
        hideTooltip
    } = useTooltipPosition(delay, position);

    const tooltipRoot = document.getElementById('react-tooltips') as HTMLElement;
    const tooltipIsVisible = disabled ? false : visible;

    return (
        <>
            <div
                ref={iconRef}
                className={styles.tooltip}
                onMouseEnter={showTooltip}
                onMouseLeave={hideTooltip}
            >
                {children || <img className={`${styles.help} ${classes.image}`} src={helpIcon} alt={t('tooltip.alt.help')} />}
            </div>

            {tooltipIsVisible &&
                ReactDOM.createPortal(
                    <span
                        className={`${styles.tooltipText} ${position === 'bottom' ? styles.bottom : ''} ${classes.text}`}
                        style={{
                            position: 'absolute',
                            top: coords.top,
                            left: coords.left,
                            transform: position === 'right'
                                ? (isRTL() ? 'translateY(-50%) translateX(-100%)' : 'translateY(-50%)')
                                : 'translateX(-50%)',
                        }}
                    >
            {text}
          </span>,
                    tooltipRoot
                )}
        </>
    );
};

export default Tooltip;
